module.exports = __webpack_public_path__ + "img/5.e7645e8b.jpg";